import { motion, AnimatePresence } from "framer-motion";

const FilePreviewModal = ({ file, onClose }) => {
  return (
    <AnimatePresence>
      <motion.div
        className="file-preview-modal"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <motion.div
          className="modal-backdrop"
          onClick={onClose}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.7 }}
          exit={{ opacity: 0 }}
        />

        <motion.div
          className="modal-content"
          layoutId={`file-${file.id}`}
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ type: "spring", damping: 25 }}
        >
          <motion.button
            className="close-btn"
            onClick={onClose}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </motion.button>

          <motion.div className="preview-container" layout>
            {file.type.startsWith("image/") ? (
              <motion.img
                src={file.data}
                alt={file.name}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                layoutId={`image-${file.id}`}
              />
            ) : file.type.startsWith("video/") ? (
              <motion.video
                controls
                autoPlay
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
                layoutId={`video-${file.id}`}
              >
                <source src={file.data} type={file.type} />
              </motion.video>
            ) : (
              <motion.div
                className="document-preview"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.2 }}
              >
                <iframe
                  src={file.data}
                  title={file.name}
                  style={{ width: "100%", height: "100%" }}
                />
              </motion.div>
            )}
          </motion.div>

          <motion.div className="file-actions" layout>
            <motion.a
              href={file.data}
              download={file.name}
              className="download-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Download
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
            </motion.a>
            <motion.div
              className="file-meta"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              <h3>{file.name}</h3>
              <p>Size: {(file.size / (1024 * 1024)).toFixed(2)} MB</p>
              <p>Uploaded: {new Date(file.uploadedAt).toLocaleString()}</p>
            </motion.div>
          </motion.div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default FilePreviewModal;
